import BootstrapData from 'models/BootstrapData';
import { getDomainAdjustedPath, getHttpForRefreshToken } from 'bizzaboAjax';
import config from 'config';
import Cookies from 'js-cookie';
import { ok as assertOk } from 'assert';


const getGroupId = () => {
    try {
        const event = BootstrapData('bootstrap-data-event');
        assertOk(event, 'no event');
        assertOk(event.groupId, 'no event.groupId');
        return event.groupId;
    } catch {
        return;
    }
};

const getAccessTokenName = () => `${config.authCookieAccess}-${getGroupId()}`;

const getAccessToken = () => Cookies.get(getAccessTokenName());

const removeAccessToken = () => {
    Cookies.remove(getAccessTokenName());
    Cookies.remove(getAccessTokenName(), { domain: window.location.hostname });
};

const removeRefreshToken = async() => {
    try {
        const httpForRefreshToken = getHttpForRefreshToken();
        await httpForRefreshToken({
            url: getDomainAdjustedPath('/userProfile/oauth/logout'),
            method: 'post'
        });
    } catch (err) {
        throw err;
    }
};

export {
    getGroupId,
    getAccessToken,
    getAccessTokenName,
    removeAccessToken,
    removeRefreshToken
};
